import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import api from '../services/api';
import { useSettings } from '../context/SettingsContext';
import BeforeAfterSlider from '../components/BeforeAfterSlider';

export default function BeforeAfterDetail() {
  const { slug } = useParams();
  const { settings } = useSettings();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    api.get(`/before-after/by-slug/${slug}`)
      .then(res => setProject(res.data))
      .catch(err => {
        if (err.response?.status === 404) setNotFound(true);
      })
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <section className="section">
        <div className="container">
          <p style={{ textAlign: 'center', padding: '3rem 0', color: '#888' }}>Yükleniyor...</p>
        </div>
      </section>
    );
  }

  if (notFound || !project) {
    return (
      <section className="section">
        <div className="container">
          <p style={{ textAlign: 'center', padding: '3rem 0', color: '#888' }}>Proje bulunamadı.</p>
          <p style={{ textAlign: 'center' }}>
            <Link to="/oncesi-sonrasi" className="btn">Tüm Projeler</Link>
          </p>
        </div>
      </section>
    );
  }

  const images = project.images || [];

  return (
    <>
      <Helmet>
        <title>{project.title} | Öncesi / Sonrası | {settings.site_title || ''}</title>
        {project.description && <meta name="description" content={project.description} />}
      </Helmet>

      <div className="page-header">
        <div className="container">
          <h1>{project.title}</h1>
          <div className="breadcrumb">
            <Link to="/">Ana Sayfa</Link>
            <span>/</span>
            <Link to="/oncesi-sonrasi">Öncesi / Sonrası</Link>
            <span>/</span>
            <span>{project.title}</span>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="container">
          {project.description && (
            <p className="ba-project-detail-description">{project.description}</p>
          )}

          {images.length === 0 ? (
            <p style={{ textAlign: 'center', padding: '2rem 0', color: '#888' }}>
              Bu projeye henüz görsel eklenmemiş.
            </p>
          ) : (
            <div className="ba-project-detail-gallery">
              {images.map((img, idx) => (
                <div key={img.id} className="ba-project-detail-item">
                  <BeforeAfterSlider before={img.before_image} after={img.after_image} />
                  {images.length > 1 && (
                    <div className="ba-project-detail-counter">{idx + 1} / {images.length}</div>
                  )}
                </div>
              ))}
            </div>
          )}

          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <Link to="/oncesi-sonrasi" className="btn btn-secondary">← Tüm Projeler</Link>
          </div>
        </div>
      </section>
    </>
  );
}
